export const reportsPrivateRoutesConstants = {
  root: {
    path: "/r/app/reports",
    href: (projectId: string) => `/r/app/reports?project=${projectId}`
  }
} as const;
